import styled, { css } from 'styled-components';

import { Button, GridRow } from 'libs/ui';

export const Row = styled(GridRow)`
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      background-color: #393e43 !important;
    `}
`;

export const ImageWrap = styled.div`
  height: 300px;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 0 !important;
  &.center {
    justify-content: center;
  }
`;

export const ClosePicturesButton = styled(Button)`
  position: absolute;
  bottom: 15px;
  left: 46%;
`;
